 import React, { useState, useEffect } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  Form,
  Table,
  Button,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import axiosInstance from "../../Request";
import { URL } from "../../api";
const Payout = ({ id ,cid, lid , aid}) => {
  const [rows, setRows] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  
  const [selectAll, setSelectAll] = useState(false);
 



  const [modal, setModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  
  const [comment, setComment] = useState("");
  const userId = localStorage.getItem("user_id");


const [leadStatus, setLeadStatus] = useState("");
  const [statusOptions, setStatusOptions] = useState([]);

  useEffect(() => {
    axiosInstance
      .get(URL.PAYOUT_PROCESS)
      .then((response) => {
        setRows(response.data);
      })
      .catch((error) => {
        console.error("Error fetching disbursal data:", error);
      });
  }, []);

  const toggleModal = () => setModal(!modal);

  const handleActionClick = (row) => {
setSelectedRow(row);
    setComment("");
    setLeadStatus("");
    toggleModal();
  };

  const handleSelectAll = () => {
    setSelectAll(!selectAll);
    if (!selectAll) {
      setSelectedRows(rows.map((r) => r.id));
    } else {
      setSelectedRows([]);
    }
  };

  const handleSelectRow = (id) => {
    setSelectedRows((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((i) => i !== id)
        : [...prevSelected, id]
    );
  };
 
const handleApproveSelected = () => {

  if (!userId) {
    alert("User ID not found in localStorage.");
    return;
  }
  if (selectedRows.length === 0) {
    alert("Please select at least one row.");
    return;
  }
 
 const queryString = selectedRows.map(id => `disbursalId=${id}`).join("&");
 
  const fullQuery = `${queryString}&user_id=${userId}`;
  axiosInstance
    .post(`${URL.PAYOUT_APPROVE}?${fullQuery}`)
    .then((res) => {
      alert(res.data);
    })
    .catch((err) => {
      console.error(err);
      alert("Error during approval");
    });
};

const handleSubmitAction = () => {
  if (!selectedRow) {
    alert("No row selected.");
    return;
  }

  if (!comment) {
    alert("Please enter a comment.");
    return;
  }

  if (!leadStatus) {
    alert("Please select a lead status.");
    return;
  }

  if (!userId) {
    alert("User ID not found in localStorage.");
    return;
  }

  const { id, leadId, customerId, applicationId } = selectedRow;   

  axiosInstance
    .post(URL.PAYOUT_UPDATE_STATUS, null, {
      params: {
        id,
        leadId,
        customerId,
        applicationId,
        message: comment,
        leadStatus,        
        userId          
      },
    })
    .then((response) => {
      alert("Comment and status submitted successfully.");
      toggleModal();  
    })
    .catch((error) => {
      console.error("Error submitting status:", error);
      alert("Submission failed.");
    });
};

// const handleSubmitAction = () => {
//   if (!selectedRow || !comment || !leadStatus) {
//     // alert("Comment and status are required.");
//     return;
//   }
//    if (!userId) {
//     alert("User ID not found in localStorage.");
//     return;
//   }

//  const { id, leadId, customerId, applicationId , user_id} = selectedRow;

//   axiosInstance
//     .post(URL.PAYOUT_UPDATE_STATUS, null, {
//       params: {
//         id,
//         leadId,
//         customerId,
//         applicationId,
//         message: comment,
//         leadStatus, // send the selected dropdown value
//         user_id
//       },
//     })
//     .then((response) => {
//       alert("Comment and status submitted!");
//       toggleModal();
//     })
//     .catch((error) => {
//       console.error("Error submitting status:", error);
//       alert("Submission failed.");
//     });
// };

 

useEffect(() => {
    axiosInstance
      .get(URL.PAYOUT_LOAN_STATUSES)
      .then((res) => {
        const customerStatuses = Object.keys(res.data.customerStatuses || {});
        const loanStatuses = Object.keys(res.data.loanStatuses || {});
        const combined = [...new Set([...customerStatuses, ...loanStatuses])];
        setStatusOptions(combined.sort());
      })
      .catch((error) => {
        console.error("Error fetching statuses:", error);
      });
  }, []); 

  return (
    <>
      <div className="header bg-gradient-info pb-6 pt-4 pt-md-7" />
      <Container className="mt--7" fluid>
        <Row className="mt-5">
          <Col xl="12">
            <Card className="shadow">
                    <CardHeader className="border-0 mx-4">
        <Row className="align-items-center">
            <Col xl="9">
            <h3 className="mb-0">Payout Request</h3>
            <div className="d-flex align-items-center mt-2">
                <Input
                type="checkbox"
                checked={selectAll}
                onChange={handleSelectAll}
                className="mr-2"
                />
                <span>Select All</span>
            </div>
            </Col>
            <Col xl="3" className="text-right">
            <Button
                color="success"
                onClick={handleApproveSelected}
                disabled={selectedRows.length === 0}
            >
                Approve Selected
            </Button>
            </Col>
        </Row>
        </CardHeader>
              <CardBody className="mx-4">
                <Form>
                  <Table bordered striped responsive>
                       <tr>
                        <th>
                         

                          Select
                            </th>
                        <th>ID</th>
                        <th>Application ID</th>
                     <th>Lead ID</th>
                        <th>Customer ID</th>
                        <th>Loan ID</th>
                        <th>Approved Amount</th>
                        <th>Disbursal Amount</th>
                        <th>Create Date</th>
                        <th>Checker ID</th>
                        <th>Checker Date</th>
                        <th>Disbursal Date</th>
                        <th>Disbursal Status</th>
                        <th>Disbursal UTR</th>
                        <th>Payout ID</th>
                        <th>Failed Reason</th>
                        <th>Description</th>
                        <th>Notes Key 1</th>
                        <th>Tracking ID</th>
                        <th>Contact ID</th>
                        <th>Fund Account ID</th>

                            <th>Action</th>  

                      </tr>
                     <tbody>
                      {rows.map((row, index) => (
                        <tr key={index}>
                          <td>
                            <Input
                              type="checkbox"
                              checked={selectedRows.includes(row.id)}
                              onChange={() => handleSelectRow(row.id)}
                            />
                          </td>

                          

                         <td>{row.id}</td>
                                                  <td>{row.applicationId}</td>
                         <td>{row.leadId}</td>

                          <td>{row.customerId}</td>
                          <td>{row.loanId}</td>
                          <td>{row.approvedAmt}</td>
                          <td>{row.disbursalAmt}</td>
                          <td>{row.createDate}</td>
                          <td>{row.checkerId}</td>
                          <td>{row.checkerDate}</td>
                          <td>{row.disbursalDate}</td>
                          <td>{row.disbursalStatus}</td>
                          <td>{row.disbursalUtr}</td>
                          <td>{row.payoutId}</td>
                          <td>{row.failedReason}</td>
                          <td>{row.description}</td>
                          <td>{row.notesKey1}</td>
                          <td>{row.trackingId}</td>
                          <td>{row.contactId}</td>
                          <td>{row.fundAccountId}</td>
                          <td>
                            <Button
                              color="primary"
                              size="sm"
                              onClick={() => handleActionClick(row)}
                            >
                              Action
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>

      {/* Modal */}
      <Modal isOpen={modal} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>Add Comment & Status</ModalHeader>
        <ModalBody>
          <div className="form-group">
            <label>Comment</label>
            <Input
              type="textarea"
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              placeholder="Enter comment"
            />
          </div>
         <div className="form-group mt-3">
  <label>Lead Status</label>
   <Input
        id="leadStatus"
        type="select"
        value={leadStatus}
        onChange={(e) => setLeadStatus(e.target.value)}
      >
        <option value="">-- Select Status --</option>
        {statusOptions.map((status, index) => (
          <option key={index} value={status}>
            {status}
          </option>
        ))}
      </Input>

</div>

        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={handleSubmitAction}
            disabled={!comment || !leadStatus}
          >
            Submit
          </Button>
          <Button color="secondary" onClick={toggleModal}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default Payout;
